import { Typography } from '@mui/material';
import type { RestoreJob } from '@repo/api-gw-sdk';

import {
  findPropertyInObject,
  type PropertyField,
} from '../queryBuilder/propertiesUtils';

export const instanceTypeField: PropertyField<RestoreJob> = {
  id: 'instanceType',
  getTitle: () => {
    return 'Instance Type';
  },
  group: 'Configuration',
  Component: ({ entity }) => {
    const instanceType = findPropertyInObject<string>(
      entity.configuration,
      'instanceType'
    );
    return instanceType && <Typography>{instanceType}</Typography>;
  },
};
